module.exports = __webpack_public_path__ + "img/cryptowar.f39049f5.png";